<template>
  <div class="address-form">
    <form class="form" :class="{ 'border': withBorder, 'form--box': withPadding }" @submit.prevent="submit()" ref="form">
      <h2 class="form__title">ข้อมูลที่อยู่</h2>

      <div class="form__item">
        <label class="form__label" for="address">ที่อยู่</label>
        <textarea class="form__input" rows="3" name="address" id="address" v-model="info.address"></textarea>
      </div>

      <div class="form__item">
        <label class="form__label" for="province">จังหวัด</label>
        <select class="form__input" name="province" id="province" v-model="info.province">
          <option :value="pItem.code" :key="pItem.code" v-for="pItem in $utils.getProvinces()">{{ pItem.name }}</option>
        </select>
      </div>

      <div class="form__item">
        <label class="form__label" for="zipcode">รหัสไปรษณีย์</label>
        <input class="form__input" type="text" name="zipcode" id="zipcode" v-model="info.postalCode" pattern="[0-9]{5}" max-length="5" />
      </div>

      <button class="btn btn--purple btn--full mt-15" v-if="showButton" @click.prevent="submit()">บันทึก</button>
    </form>
  </div>
</template>

<script>
  import Cart from './Cart.vue'
  import PaymentSummary from './PaymentSummary.vue'

  export default {
    components: {
      PaymentSummary,
      Cart
    },
    name: 'AddressForm',
    created () {
      this.loadInfo()
    },
    unmounted () {
      this.$store.dispatch('setBackVisibility', true)
    },
    props: {
      showButton: {
        type: Boolean,
        required: false,
        default: true
      },
      back: {
        type: Boolean,
        required: false,
        default: true
      },
      next: {
        type: String,
        required: false,
        default: ''
      },
      withBorder: {
        type: Boolean,
        required: false,
        default: true
      },
      withPadding: {
        type: Boolean,
        required: false,
        default: true
      },
      paymentMode: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data () {
      return {
        info: {
          address: '',
          province: '',
          postalCode: '',
          phone: '',
          deliveryMethod: ''
        }
      }
    },
    methods: {
      loadInfo () {
        this.$store.dispatch('initCheckoutInfo')
        Object.assign(this.info, this.$store.state.checkoutInfo)
      },
      validate () {
        return true
      },
      submit () {
        this.$store.dispatch('updateCheckoutInfo', this.info)
        this.$emit('saved', this.info)

        if (this.next && this.next.trim() !== '') {
          this.$router.push(this.next)
          return
        }

        if (this.back) {
          this.$router.back()
        }
      }
    }
  }
</script>

<style scoped lang="less">
//
// .profile-page .address-form .form.form--box {
//   padding: 0;
// }
</style>



// WEBPACK FOOTER //
// AddressForm.vue?25bdf6e9